import { render, staticRenderFns } from "./StoreBranding.vue?vue&type=template&id=bcceadc0&scoped=true&"
import script from "./StoreBranding.vue?vue&type=script&lang=js&"
export * from "./StoreBranding.vue?vue&type=script&lang=js&"
import style0 from "./StoreBranding.vue?vue&type=style&index=0&id=bcceadc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcceadc0",
  null
  
)

export default component.exports